import Vue from 'vue';
import Vuex from 'vuex';
// import * as actions from './actions';
// import * as getters from './getters';
import user from './modules/user';
import devices from './modules/devices';
import menu from './modules/menu';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		user,
		devices,
		menu
	},
	strict: true,
	plugins: [createPersistedState()]
});



// WEBPACK FOOTER //
// ./app/store/index.js